import React from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { formatDateTime, maskAccount } from '../../utils/redemptionHelpers';

const BankDetailsCard = ({ bank, showAccount, setShowAccount, isSupport }) => {
  const maskedAccountNumber = React.useMemo(() => {
    if (!bank) return 'N/A';
    const accountNumber = bank?.bank_details?.account_number || bank?.accountFull || '';
    return maskAccount(accountNumber);
  }, [bank]);

  return (
    <div className="bg-white rounded-md shadow-sm border border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-900 flex items-center">
          <span className="mr-2">Bank & Payout Details</span>
        </h2>
      </div>
      <div className="p-4 sm:p-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8">
          <div className="space-y-4">
            <div>
              <div className="text-xs text-gray-500 mb-1">Account Holder Name</div>
              <div className="text-sm font-medium text-gray-900">
                {bank?.bank_details?.account_holder_name || bank?.holder || 'N/A'}
              </div>
            </div>
            <div>
              <div className="text-xs text-gray-500 mb-1">IFSC Code</div>
              <div className="text-sm font-medium text-gray-900">
                {bank?.bank_details?.ifsc_code || bank?.ifsc || 'N/A'}
              </div>
            </div>
            <div>
              <div className="text-xs text-gray-500 mb-1">Status</div>
              <div className="text-sm font-medium text-gray-900">
                {(() => {
                  const statusValue = bank?.bank_details?.status || bank?.status || 'N/A';
                  const isNA = statusValue === 'N/A' || statusValue === 'NA' || statusValue === 'n/a' || statusValue === 'na';
                  return (
                    <span className={isNA ? 'text-gray-700' : 'text-green-600'}>
                      {statusValue}
                    </span>
                  );
                })()}
              </div>
            </div>
          </div>
          <div className="space-y-4">
            <div>
              <div className="text-xs text-gray-500 mb-1">Account Number</div>
              <div className="text-sm font-medium text-gray-900 flex items-center space-x-2">
                <span>
                  {(() => {
                    // Support always sees unmasked, Finance and SuperAdmin can toggle
                    const accountNumber = isSupport
                      ? (bank?.bank_details?.account_number || bank?.accountFull) 
                      : (showAccount ? (bank?.bank_details?.account_number || bank?.accountFull) : maskedAccountNumber);
                    return accountNumber && accountNumber.trim() !== '' ? accountNumber : 'N/A';
                  })()}
                </span>
                {!isSupport && (bank?.bank_details?.account_number || bank?.accountFull) && (
                  <button
                    onClick={() => setShowAccount(v => !v)}
                    className="text-gray-400 hover:text-gray-600"
                    aria-label={showAccount ? 'Hide account' : 'Show account'}
                  >
                    {showAccount ? <FaEyeSlash /> : <FaEye />}
                  </button>
                )}
              </div>
            </div>
            <div>
              <div className="text-xs text-gray-500 mb-1">Bank Name</div>
              <div className="text-sm font-medium text-gray-900">
                {bank?.bank_details?.bank_name || bank?.bankName || 'N/A'}
              </div>
            </div>
            <div>
              <div className="text-xs text-gray-500 mb-1">Last Verified</div>
              <div className="text-sm font-medium text-gray-900">
                {formatDateTime(bank?.last_verified || bank?.bank_details?.last_verified) || 'N/A'}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BankDetailsCard;

